import React from 'react'
import CarouselComponent from '../../components/carousel/Carousel'
import Discounts from '../../components/discounts/Discounts'
import Icons from '../../components/icons/Icons'
import Items from './items/Items'
import Newsletter from '../../components/newsletter/Newsletter'

const HomePage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <CarouselComponent />
      <Discounts />
      <Items />
      <Icons />
      <Newsletter />
    </div>

  )
}

export default HomePage